export default (axios, baseURL) => async (clientSid, file) => {
  const url = `/v2/clients/student-management/grouping/csv-to-json`;

  const formData = new FormData();
  formData.append('file', file);

  const axiosConfig = {
    method: 'POST',
    baseURL,
    url,
    headers: {
      'x-impersonated-client-sid': clientSid
    },
    data: formData
  };
  try {
    const axiosResponse = await axios(axiosConfig);

    if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
      throw new Error('Invalid response from gateway');
    }
    return axiosResponse.data;
  } catch (error) {
    if (error.response && error.response.data) {
      return { error: error.response.data };
    }
    throw error;
  }
};
